@if (mapItems) {
    <section
        class="map-sidebar"
        [class.map-sidebar--full-height]="showMapItems || (shouldShowDetailView$ | async)"
    >
        @if (isMinimized) {
            <ui-maximize-sidebar-button (click)="sidebarMaximized.emit()"/>
        }
        @if (!isMinimized && (mapItems.data ?? []); as data) {
            <ng-content select="[filters]"/>
            <div class="map-sidebar__result-header-wrapper">
                <h2 class="map-sidebar__result-header">
                    Ergebnisse {{
                        mapItems.data
                            ? '(' + mapItems.data.length + ')'
                            : ''
                    }}
                </h2>
                <ui-sidebar-item-display-toggle
                    [(display)]="showMapItemsAsList"
                />
            </div>
            @if (mapItems.error?.key === loadingStatus) {
                <ui-map-sidebar-items-skeleton
                    [class.map-sidebar__results--hidden-mobile]="!showMapItems"
                    [displayAsList]="showMapItemsAsList || isMobile"
                />
            } @else {
                @if (data.length > 0) {
                    <ui-map-sidebar-items
                        class="map-sidebar__results"
                        [class.map-sidebar__results--hidden-mobile]="!showMapItems"
                        [mapItems]="data"
                        [gridContentComponentType]="gridContentComponentType"
                        [listCustomContentComponentType]="listCustomContentComponentType"
                        [displayAsList]="showMapItemsAsList || isMobile"
                        (mapItemClicked)="onMapItemClicked($event)"
                    />
                } @else if (hasFilter$()) {
                    <p
                        class="mx-l mt-m color-grey-light"
                        [class.map-sidebar__results--hidden-mobile]="!showMapItems"
                    >
                        Ihre Suche brachte keine Ergebnisse.
                    </p>
                } @else {
                    <p
                        class="mx-l mt-m color-grey-light"
                        [class.map-sidebar__results--hidden-mobile]="!showMapItems"
                    >
                        Es sind keine Einträge vorhanden.
                    </p>
                }
            }

            @if (showMapItems) {
                <ui-show-map-button (click)="switchToMap.emit()"/>
            }
        }
        @if ((selectedMapItem$ | async) !== null && !isMinimized &&
            ((shouldShowDetailView$ | async) === true || !isMobile)) {
            <div
                class="map-sidebar__map-item-details-wrapper"
            >
                <div class="map-sidebar__map-item-details-close-button-wrapper">
                    <button
                        class="map-sidebar__map-item-details-close-button"
                        (click)="closeMapItemDetails()"
                    >
                        <ui-icon
                            aria-hidden
                            class="map-sidebar__map-item-details-close-button-icon"
                            [icon]="'close-large'"
                        />
                    </button>
                </div>

                <ng-content select="[map-item-details]"/>
            </div>
        }
    </section>
}
